export const TOAST_TRANSFORMS = {
  toast: {
    in: 'translateX(0)',
    out: 'translateX(-100%)'
  },
  inline: {
    in: 'translate(-50%, 0)',
    out: 'translate(-50%, -100%)'
  }
};

export const TIME_TO_DELETE = 300;
export const TIME_TO_LIVE = 5000;

export const TRANSITION_PROPS = {
  from: {
    opacity: 0,
    transform: 'translate(0, 3.125rem)'
  },
  enter: {
    opacity: 1,
    transform: 'translate(0, 0)'
  },
  leave: {
    opacity: 0,
    transform: 'translate(0, 3.125rem)'
  },
  duration: 400
};
